export enum SideNavIds {
	ACCUEIL = "ACCUEIL",

	// Default
	ORDONNANCES = "ORDONNANCES",
	ORDONNANCES_LISTE = "ORDONNANCES_LISTE",
	ORDONNANCES_PRESCRIPTION_IPA = "ORDONNANCES_PRESCRIPTION_IPA",
	CABINET = "CABINET",
	CABINET_PLANNING = "CABINET_PLANNING",
	CABINET_REMPLACANTS = "CABINET_REMPLACANTS",
	PAIEMENT = "PAIEMENT",
	PAIEMENT_FACTURES = "PAIEMENT_FACTURES",
	PAIEMENT_EFACTURES = "PAIEMENT_EFACTURES",
	PAIEMENT_TELETRANSMISSIONS = "PAIEMENT_TELETRANSMISSIONS",
	PAIEMENT_MES_REGLEMENTS = "PAIEMENT_MES_REGLEMENTS",
	PAIEMENT_REJETS = "PAIEMENT_REJETS",
	PATIENTELE = "PATIENTELE",
	PATIENTELE_PATIENTS = "PATIENTELE_PATIENTS",
	PATIENTELE_AGENDA = "PATIENTELE_AGENDA",
	PATIENTELE_COORDINATION = "PATIENTELE_COORDINATION",

	// Admin Hotline
	DASHBOARD_ADMIN_HOTLINE = "DASHBOARD_ADMIN_HOTLINE",
	CLIENTS = "CLIENTS",
	CLIENTS_LISTE_CLIENTS = "CLIENTS_LISTE_CLIENTS",
	CLIENTS_LISTE_CABINETS = "CLIENTS_LISTE_CABINETS",
	CLIENTS_ADMIN_GP = "CLIENTS_ADMIN_GP",
	ANNUAIRES = "ANNUAIRES",
	ANNUAIRES_MUTUELLES = "ANNUAIRES_MUTUELLES",
	MAJ_CBALINK = "MAJ_CBALINK",
	MAJ_CBALINK_LISTE_MAJ = "MAJ_CBALINK_LISTE_MAJ",
	MAJ_CBALINK_CREATION_MAJ = "MAJ_CBALINK_CREATION",

	// Admin Marketing
	PUBLICITES = "PUBLICITES",
	INFO_DU_MOMENT = "INFO_DU_MOMENT",
	ALERTES = "ALERTES",
}
